import { loadablePage } from 'src/utils/loadable';

export default loadablePage(
  () =>
    import(
      /* webpackChunkName: "MailPrevModal" */ /* webpackPrefetch: true */
      './MailPrevModal.component'
    ),
);
